import { useMutation, useQueryClient } from '@tanstack/react-query'
import { baseUrl } from 'api/config'
import axios from 'axios'

// shape of the variables you pass to mutate(...)
type UpdateDealVars = {
  PK: string
  SK: string
  dealData: any // ideally your Deal type
}

// server returns; use your real type if you have one
type UpdateDealData = any

// context you return from onMutate
type UpdateDealCtx = { previousDeal?: any }

export const useUpdateDealItems = () => {
  const queryClient = useQueryClient()

  return useMutation<UpdateDealData, unknown, UpdateDealVars, UpdateDealCtx>({
    mutationFn: async ({ PK, SK, dealData }) => {
      const url = `${baseUrl}/aws/organizations_table/updatedeal/${PK}/${SK}`
      const { data } = await axios.put(url, dealData)
      return data
    },

    onMutate: async ({ PK, SK, dealData }) => {
      await queryClient.cancelQueries({ queryKey: ['item', PK, SK] })
      const previousDeal = queryClient.getQueryData(['item', PK, SK])

      queryClient.setQueryData(['item', PK, SK], (old: any) => ({
        ...(old ?? {}),
        ...dealData,
      }))

      return { previousDeal }
    },

    onError: (err, { PK, SK }, ctx) => {
      if (ctx?.previousDeal) {
        queryClient.setQueryData(['item', PK, SK], ctx.previousDeal)
      }
    },

    // don't destructure a {dealId} that doesn't exist; let TVariables be {PK,SK,dealData}
    onSuccess: (_data, { PK, SK }) => {
      // if you want, revalidate the specific item
      queryClient.invalidateQueries({ queryKey: ['item', PK, SK] })
    },
  })
}
